module.exports = "//cdn.cnbj2m.fds.api.mi-img.com/rdp-outer/qiankun-admin/202601191108228/img/404.3ec06ef5.jpg";